export function compareMonth(eventMonth) {
  const now = new Date();
  if (eventMonth >= now.getMonth() + 1) {
    return true;
  } else {
    return false;
  }
}
